import isLastTextNodeOfElement from '../verifiers/is-last-text-node-of-element';
import setCaretAtTheBeginningOfNode from './set-caret-at-the-beginning-of-node';
import insertBreakIntoEditableElement from './insert-break-into-editable-element';
import getCollapsedNodeAndOffset from './get-collapsed-node-and-offset';

const handleHeadingElement = (element) => {
  const [node, offset] = getCollapsedNodeAndOffset();
  const { ownerDocument: liveDocument } = element;

  if (isLastTextNodeOfElement(node, element) && node.length === offset) {
    const paragraph = liveDocument.createElement('p');
    const breakElement = liveDocument.createElement('br');
    paragraph.appendChild(breakElement);
    element.insertAdjacentElement('afterend', paragraph);
    setCaretAtTheBeginningOfNode(breakElement);
    return;
  }

  insertBreakIntoEditableElement();
};

export default handleHeadingElement;
